<template>
    <tr class="c-tr" @click="openDonationDetails">
        <td>{{ data.full_name }}</td>
        <td>{{ data.phone }}</td>
        <td>{{ data.email }}</td>
        <td>{{ data.added_on ? formatDate(data.added_on) : '' }}</td>
        <td align="right">{{ formatCurrency(data.amount) }}</td>
    </tr>
</template>

<script>
export default {
    name: 'TableItem',
    props: {
        data: Object,
    },
    methods: {
        openDonationDetails() {
            this.$emit('openDonationDetails', this.data);
        },
        formatDate(date) {
            return this.$moment(date).format('MM/DD/YYYY');
        },
        formatCurrency(amount) {
            return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(amount);
        },
    },
};
</script>

<style lang="scss" scoped>
.c-tr {
    td {
        color: #7c7c7a;
        font-size: 16px;
        font-weight: 600;
        line-height: 24px;
        cursor: pointer;

        &:first-child {
            min-width: 200px;
        }
    }
}
</style>
